<template>
	<a
		href="#"
		@click.prevent="activeModuleStats(module)"
		class="module-card-wrapper"
	>
		<div class="module-card" :class="module.color_scheme">
			<div
				class="module-card-body"
				:style="'background-image: url(' + module.image + ');'"
			>
				<div class="module-card-body-content">
					<h4 class="module-card-title">{{ module.name }}</h4>
				</div>
			</div>
			<div class="module-card-bottom">
				<p>
					Se svar
					<Icon
						class="margin-left-xs-1 icon-17"
						:icon="'arrow-thin-right'"
					/>
				</p>
			</div>
		</div>
	</a>
</template>
<script>
import Icon from "./../partials/Icon.vue";
export default {
	name: "OwnerModuleCard",
	props: ["module"],
	components: { Icon },
	computed: {},
	methods: {
		activeModuleStats(module) {
			this.$store.commit("activeModuleStats", module);
			this.$store.dispatch("scrollToAppTop");
		}
	},
	mounted() {}
};
</script>